// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable */
.DropdownMenu_dropdownContainer__oRDZG {
  position: relative;
  margin: 0 auto;
}

.DropdownMenu_dropdownContainer__oRDZG a {
  display: flex;
  flex-direction: row;
}

.DropdownMenu_deletePadding__oSjFx {
  padding-left: 5px;
  padding-right: 5px;
}

.DropdownMenu_dropdownHeader__KwLN2 {
  gap: 14px;
}
.DropdownMenu_dropdownHeader__KwLN2 .DropdownMenu_iconDown__Oq5TI {
  display: none;
}
@media (md) {
  .DropdownMenu_dropdownHeader__KwLN2 .DropdownMenu_iconWorld__Y8GZH {
    display: none;
  }
}
@media (sm) {
  .DropdownMenu_dropdownHeader__KwLN2 .DropdownMenu_iconDown__Oq5TI {
    display: inline;
  }
}

.DropdownMenu_dropdownListWrapper__e9WBU {
  position: absolute;
  z-index: 100000;
  width: 100%;
  left: 0;
  margin-top: 10px;
  box-shadow: 0px 0px 5px #ccc;
}

.DropdownMenu_dropdownHeaderText__p79Ji {
  display: flex;
  align-items: center;
  gap: 8px;
}

.DropdownMenu_dropdownListContainer__fkJDX {
  width: 100%;
  min-width: 220px;
}

.DropdownMenu_dropdownList__VFg5v {
  padding: 0;
  margin: 0;
  background: #fff;
  border: 1px solid #d4d4d4;
  box-sizing: border-box;
  border-radius: 4px;
}
.DropdownMenu_dropdownList__VFg5v .DropdownMenu_listItemContainer__xtSkF {
  list-style: none;
  align-items: flex-start;
  gap: 8px;
}
.DropdownMenu_dropdownList__VFg5v .DropdownMenu_listItem__JcGay {
  padding-left: 1em;
  padding: 10px 20px;
  display: flex;
  font-size: 14px;
}
.DropdownMenu_dropdownList__VFg5v .DropdownMenu_listItem__JcGay:hover {
  background: #dedede;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/DropdownMenu/DropdownMenu.module.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAAA,sBAAA;AAKA;EACE,kBAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,SAAA;AAHF;AAKE;EACE,aAAA;AAHJ;AAOI;EADF;IAEI,aAAA;EAJJ;AACF;AAQI;EADF;IAEI,eAAA;EALJ;AACF;;AASA;EACE,kBAAA;EACA,eCZiB;EDajB,WAAA;EACA,OAAA;EACA,gBAAA;EACA,4BAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANF;;AASA;EACE,WAAA;EACA,gBAAA;AANF;;AASA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AANF;AAQE;EACE,gBAAA;EACA,uBAAA;EACA,QAAA;AANJ;AASE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAPJ;AASI;EACE,mBAAA;AAPN","sourcesContent":["/* stylelint-disable */\n@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.dropdownContainer {\n  position: relative;\n  margin: 0 auto;\n}\n\n.dropdownContainer a {\n  display: flex;\n  flex-direction: row;\n}\n\n.deletePadding {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.dropdownHeader {\n  gap: 14px;\n\n  .iconDown {\n    display: none;\n  }\n\n  .iconWorld {\n    @media (md) {\n      display: none;\n    }\n  }\n\n  .iconDown {\n    @media (sm) {\n      display: inline;\n    }\n  }\n}\n\n.dropdownListWrapper {\n  position: absolute;\n  z-index: $top-most-z-index;\n  width: 100%;\n  left: 0;\n  margin-top: 10px;\n  box-shadow: 0px 0px 5px #ccc;\n}\n\n.dropdownHeaderText {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dropdownListContainer {\n  width: 100%;\n  min-width: 220px;\n}\n\n.dropdownList {\n  padding: 0;\n  margin: 0;\n  background: #fff;\n  border: 1px solid #d4d4d4;\n  box-sizing: border-box;\n  border-radius: 4px;\n\n  .listItemContainer {\n    list-style: none;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .listItem {\n    padding-left: 1em;\n    padding: $padding-m $padding-l;\n    display: flex;\n    font-size: 14px;\n\n    &:hover {\n      background: #dedede;\n    }\n  }\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `DropdownMenu_dropdownContainer__oRDZG`,
	"deletePadding": `DropdownMenu_deletePadding__oSjFx`,
	"dropdownHeader": `DropdownMenu_dropdownHeader__KwLN2`,
	"iconDown": `DropdownMenu_iconDown__Oq5TI`,
	"iconWorld": `DropdownMenu_iconWorld__Y8GZH`,
	"dropdownListWrapper": `DropdownMenu_dropdownListWrapper__e9WBU`,
	"dropdownHeaderText": `DropdownMenu_dropdownHeaderText__p79Ji`,
	"dropdownListContainer": `DropdownMenu_dropdownListContainer__fkJDX`,
	"dropdownList": `DropdownMenu_dropdownList__VFg5v`,
	"listItemContainer": `DropdownMenu_listItemContainer__xtSkF`,
	"listItem": `DropdownMenu_listItem__JcGay`
};
export default ___CSS_LOADER_EXPORT___;
